module.exports = __webpack_public_path__ + "static/media/2.c670a6d2.png";